import React, { useEffect, useState } from 'react';
import styles from './CustomToggleRefinement.module.scss';
import {
    UseMenuProps,
    useInstantSearch,
    useMenu,
    // useToggleRefinement,
    // UseToggleRefinementProps
} from 'react-instantsearch';
import { LeumitDoctor, MashlimDoctor } from 'assets/constants';
import { getAllClassNames } from 'helpers';
import strings from "assets/strings";
import { Loader } from 'assets/images';

export interface CustomToggleRefinementProps extends UseMenuProps {
    setIsLeumit: (value: boolean) => void;
}

export function CustomToggleRefinement(props: CustomToggleRefinementProps) {
    const { items, refine } = useMenu(props);
    const [toggleState, setToggleState] = useState<string>('LeumitDoctor');
    const { setIsLeumit } = props;
    const leumitDoctor = items.find(item => item.value === "LeumitDoctor") || undefined;
    const externalDoctor = items.find(item => item.value === "ExternalDoctor") || undefined;
    const { scopedResults, results } = useInstantSearch();

    useEffect(() => {
        if (!scopedResults) return;
        if (!results || results.__isArtificial) return;
        const doctorsIndex = scopedResults.filter(i => i.indexId === 'DOCTORS_INDEX');
        const exactIndex = scopedResults.filter(i => i.indexId === 'exact');
        const geoIndex = scopedResults.filter(i => i.indexId === 'geo');
        let totalLeumitDoctorResults = 0;
        let totalExternalDoctorResults = 0;
        if (exactIndex.length) {
            totalLeumitDoctorResults = (exactIndex[0]?.results?._rawResults[exactIndex[0]?.results?._rawResults?.length - 1]?.facets?.type?.LeumitDoctor ?? 0);
            totalExternalDoctorResults = (exactIndex[0]?.results?._rawResults[exactIndex[0]?.results?._rawResults?.length - 1]?.facets?.type?.ExternalDoctor ?? 0);
            if (geoIndex) {
                totalLeumitDoctorResults += (geoIndex[0]?.results?._rawResults[geoIndex[0]?.results?._rawResults?.length - 1]?.facets?.type?.LeumitDoctor ?? 0);
                totalExternalDoctorResults += (geoIndex[0]?.results?._rawResults[geoIndex[0]?.results?._rawResults?.length - 1]?.facets?.type?.ExternalDoctor ?? 0);
            }
        } else {
            totalLeumitDoctorResults = (doctorsIndex[0]?.results?._rawResults[doctorsIndex[0]?.results?._rawResults?.length - 1]?.facets?.type?.LeumitDoctor ?? 0);
            totalExternalDoctorResults = (doctorsIndex[0]?.results?._rawResults[doctorsIndex[0]?.results?._rawResults?.length - 1]?.facets?.type?.ExternalDoctor ?? 0);
        }
               
        if (totalLeumitDoctorResults == 0 && totalExternalDoctorResults > 0 && toggleState == 'LeumitDoctor') {
            refine('ExternalDoctor');
            setIsLeumit(false);
            setToggleState('ExternalDoctor');
        }

    }, [results]);

    const handleKeyDown = (event: React.KeyboardEvent<HTMLSpanElement>) => {
        if (event.key === "Enter") {
            // Simulate a click event on the focused element
            const target = event.target as HTMLElement;
            target.click();
            return;
        }
    };

    const Totals = ({ isLeumit, ...props }: { isLeumit: boolean, id?: string }) => {
        const { scopedResults, results } = useInstantSearch();
        const [doctorsHits, setDoctorsHits] = useState<number | null>(null); // Store the count
        const [finalDoctorsHits, setFinalDoctorsHits] = useState<number | null>(null);  // Store final count to prevent flickering
        const textAlignStyle: React.CSSProperties = finalDoctorsHits === null ? { display: 'flex', justifyContent: 'center', height: '20px', margin: 'auto', borderRadius: '100%', overflow: 'hidden' } : {}; // Align text to the right while calculating
        
        useEffect(() => {
            console.log('*** CustomToggleRefinement:Totals:useEffect', doctorsHits);
            if (!scopedResults || !results || results.__isArtificial) return;

            const doctorsIndex = scopedResults.filter(i => i.indexId === 'DOCTORS_INDEX');
            const exactIndex = scopedResults.filter(i => i.indexId === 'exact');
            const geoIndex = scopedResults.filter(i => i.indexId === 'geo');

            let totalResults = 0;

            if (exactIndex.length) {
                if (isLeumit) {
                    totalResults = exactIndex[0]?.results?._rawResults[exactIndex[0]?.results?._rawResults.length - 1]?.facets?.type?.LeumitDoctor ?? 0;
                    if (geoIndex) {
                        totalResults += geoIndex[0]?.results?._rawResults[geoIndex[0]?.results?._rawResults.length - 1]?.facets?.type?.LeumitDoctor ?? 0;
                    }
                } else {
                    totalResults = exactIndex[0]?.results?._rawResults[exactIndex[0]?.results?._rawResults.length - 1]?.facets?.type?.ExternalDoctor ?? 0;
                    if (geoIndex) {
                        totalResults += geoIndex[0]?.results?._rawResults[geoIndex[0]?.results?._rawResults.length - 1]?.facets?.type?.ExternalDoctor ?? 0;
                    }
                }
            } else {
                if (isLeumit) {
                    totalResults = doctorsIndex[0]?.results?._rawResults[doctorsIndex[0]?.results?._rawResults.length - 1]?.facets?.type?.LeumitDoctor ?? 0;
                } else {
                    totalResults = doctorsIndex[0]?.results?._rawResults[doctorsIndex[0]?.results?._rawResults.length - 1]?.facets?.type?.ExternalDoctor ?? 0;
                }
            }

            setDoctorsHits(totalResults); // Update temporary value
            // Add a short delay to ensure a smooth update
            const timeout = setTimeout(() => {
                setFinalDoctorsHits(totalResults); // Finalize the value
            }, 300); // Adjust the delay as necessary

            return () => clearTimeout(timeout); // Cleanup timeout
        }, [results]);
       
        return (
            <div style={textAlignStyle} {...props}>
                {finalDoctorsHits === null ? <img src={Loader} /> : `${finalDoctorsHits} ${isLeumit ? strings.doctorSearchResults.leumitDoctors : strings.doctorSearchResults.mashlimDoctors}`}
            </div>
        );
    };

    const handleToggleBar = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === ' ') {
            e.preventDefault();
            const currentState = toggleState === 'LeumitDoctor' ? 'ExternalDoctor' : 'LeumitDoctor'
            setToggleState(currentState);
            refine(currentState);
            setIsLeumit(currentState === 'LeumitDoctor' ? true : false);
        }
    }

    return (
        <div className={styles.refineContainer} role="radiogroup" aria-checked={toggleState == 'LeumitDoctor' ? false : true} tabIndex={0} onKeyDown={handleToggleBar} aria-label={strings.doctorSearchResults.toggleDoctorType}>
            <span
                aria-checked={toggleState === 'LeumitDoctor' ? true : false}
                // aria-label='רופאי לאומית'
                aria-labelledby='leumit'
                role="radio"
                tabIndex={0}
                key={LeumitDoctor}
                className={getAllClassNames([
                    styles.span,
                    (items.length == 0 || leumitDoctor?.isRefined) && styles.selected,
                ])}
                onClick={(event) => {
                    if (toggleState === 'LeumitDoctor' || !leumitDoctor) {
                        // Disable click if already selected
                        event.preventDefault();
                        return;
                    }
                    event.preventDefault();
                    refine('LeumitDoctor');
                    setIsLeumit(true);
                    setToggleState('LeumitDoctor');
                }}
                onKeyDown={handleKeyDown}
            >
                <Totals isLeumit id="leumit"/>
            </span>
            <span
                aria-checked={toggleState === 'ExternalDoctor' ? true : false}
                //aria-label='רופאים בביטוח המשלים'
                aria-labelledby='external'
                role="radio"
                tabIndex={0}
                //tabIndex={toggleState === MashlimDoctor ? 0 : -1}
                key={MashlimDoctor}
                className={getAllClassNames([
                    styles.span,
                    externalDoctor?.isRefined && styles.selected,
                ])}
                onClick={(event) => {
                    if (toggleState === 'ExternalDoctor' || !externalDoctor) {
                        // Disable click if already selected
                        event.preventDefault();
                        return;
                    }
                    event.preventDefault();
                    refine('ExternalDoctor');
                    setIsLeumit(false);
                    setToggleState('ExternalDoctor');
                }}
                onKeyDown={handleKeyDown}
            >
                <Totals isLeumit={false} id="external"/>
            </span>
        </div>
    );
}


